// tempraroy enum

export const responseEnum = {
  FailureCode: 0,
  SuccessCode: 1,
  ValidationCode: 400,
  ForbiddenCode: 403,
  InternalServerCode: 500,
}

export const MainInventoryType = {
  BasePaper: 1,
  Film: 2,
  Chemical: 3,
  Ink: 4,
  PackagingMaterial: 5,
  Other: 6
}

export const InventoryTypeInum = {
  Unit: 1,
  CompanyName: 2,
  Group: 3,
  SubGroup: 4,
  Size: 5,
  Color: 6,
  TypeOfPaper: 7,
  Micron: 8,
  ChemicalName: 9,
  ChemicalCategory: 10,
  ChemicalCode: 11,
  PantoneNumber: 12,
  releaseStatus: 13,
}